'use client'

import type { Data } from '@repo/strapi-types'
import { BlogCategoriesRow } from '@/app/[locale]/blog/_components/BlogCategoriesRow'
import AppLink from '@/components/elementary/AppLink'
import { Scrollable } from '@/components/elementary/Scrollable'
import Heading from '@/components/typography/Heading'
import { cn } from '@/lib/styles'
import { EDITORS_PICK_TEST_IDS } from '@/lib/test-ids'
import { getArticleLink } from '@/utils/links'

export function EditorsPick({
	component,
	className,
}: {
	component: Data.Component<'blog.editors-pick'>
	className?: string
}) {
	const { title, articles } = component

	return (
		<div
			className={cn('py-8 lg:pt-10 lg:pb-9 border-y border-brand-salmon', className)}
			data-test-id={EDITORS_PICK_TEST_IDS.COMPONENT}
		>
			{title && (
				<Heading tag="h2" fontSize="headingMedium" className="mb-6">
					{title}
				</Heading>
			)}
			<Scrollable
				className="h-66.5 md:h-62.5 lg:h-72.5"
				scrollableClassName="flex flex-col gap-4 max-h-66.5 md:max-h-62.5 lg:max-h-72.5 overflow-y-scroll"
				data-test-id={EDITORS_PICK_TEST_IDS.COMPONENT}
			>
				{articles?.map((article) => (
					<div key={article.id} className="flex flex-col gap-2">
						{article.blogCategories && article.blogCategories.length > 0 && (
							<BlogCategoriesRow categories={article.blogCategories} type="small" />
						)}
						{article.slug && (
							<AppLink
								href={getArticleLink(article.slug)}
								size="none"
								className="w-fit"
								data-test-id={EDITORS_PICK_TEST_IDS.ARTICLE_LINK}
							>
								<Heading
									textColor="link"
									tag="h3"
									fontSize="bodyRegularLarge"
									className="line-clamp-2"
								>
									{article.title}
								</Heading>
							</AppLink>
						)}
					</div>
				))}
			</Scrollable>
		</div>
	)
}
